import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import useSupportResource from "../../hooks/useSupportResource";
import { getSupportStoreWorkspace } from "../../services/supportApi";

const StoreWorkspaceContext = createContext(null);

export const StoreWorkspaceProvider = ({ children }) => {
  const { id } = useParams();
  const resource = useSupportResource({
    load: ({ signal }) => getSupportStoreWorkspace(id, { signal }),
    resourceKey: `store-workspace:${id}`,
    pollIntervalMs: 30_000,
  });

  return (
    <StoreWorkspaceContext.Provider value={{ ...resource, shopId: id }}>
      {children}
    </StoreWorkspaceContext.Provider>
  );
};

export const useStoreWorkspace = () => {
  const context = useContext(StoreWorkspaceContext);
  if (!context) {
    throw new Error("useStoreWorkspace must be used inside StoreWorkspaceProvider");
  }
  return context;
};

export default StoreWorkspaceContext;
